import {IStateStore}                       from '../../ap-interface';
import {Store}                             from '../index';
import {Injectable}                        from '@angular/core';
import {WorktypeLoad, WorktypeLoadSuccess} from 'invoker-transport';
import {TranslationStore}                  from '../translation/translation.store';
import {ApSignalrService}                  from '../../ap-core/services/ap-signalr.service';
import {SafeBehaviorSubject}               from 'ts-tooling';
import IWorktypes = Data.BaseData.IWorktypes;

interface IWorkTypesStore extends IStateStore<IWorktypes> {
}

export enum WorkTypeCategory {
  Soil_Cultivation = 0,
  Tillage = 1,
  Fertilisation = 2,
  PlantProtection = 3,
  Valuation = 4,
  Harvest = 5,
  Others = 10,
  Transport = 13
}

/**
 * The workType ids are same over all systems
 * => let's use its id's to identify specific worktypes
 */
export enum WorkTypes {
  Spraying = 4
}

@Injectable({providedIn: 'root'})
export class WorkTypesStore extends Store<IWorkTypesStore> {
  constructor(public backend: ApSignalrService,
              private translationStore: TranslationStore) {
    super(backend, {
      loaded: false,
      loading: false,
      data: [],
    });
    backend.registerObservable(WorktypeLoadSuccess).subscribe(d => {
      super.Mutate(s => s.data, () => d.Data.Convert(_ => {
        _.Shortname = this.translationStore.FindTranslationForSelectedLanguage(_.Shortname);
        _.Description = this.translationStore.FindTranslationForSelectedLanguage(_.Description);
        return _;
      }));
      super.SetLoadFinishState();
    });
    this.AfterDatabaseUpdate.subscribe(() => this.ReloadSource());
  }

  public get Loading$(): SafeBehaviorSubject<boolean> {
    return this.Listen(x => x.loading);
  }

  public get WorkTypes$(): SafeBehaviorSubject<IWorktypes[]> {
    return this.Listen(x => x.data);
  }

  public get WorkTypes(): IWorktypes[] {
    return this.WorkTypes$.getValue();
  }

  /**
   *  load worktypes from Backend to the Store
   */
  public loadWorktypes(): void {
    super.SetLoadState();
    super.Mutate(s => s.data, () => []);
    this.DispatchBackend(new WorktypeLoad([]));
  }
}
